import React from "react";
import { faCircleExclamation } from '@fortawesome/free-solid-svg-icons';
import Modal from 'react-bootstrap/Modal';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { getApi } from "../../api/endpoints";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { selectQueryParams, setQueryParams, updateQueryParams } from "../../ui/customerListingReducer";

const MarkDefectiveModal = (props) => {
  const {showMarkDefectiveModal, setShowMarkDefectiveModal, rfidDetails} = props;
  const [markDefectiveRfidApi] = getApi('markDefectiveRfid');
  const queryParams = useSelector(selectQueryParams);
  const dispatch = useDispatch();

  const handleModalClose = () => {
    setShowMarkDefectiveModal(false);
  }

  const onMarkDefectiveRfidClick = async () => {
    try{
      const response = await markDefectiveRfidApi({id: `${rfidDetails.id}`}).unwrap();
      setShowMarkDefectiveModal(false);
      toast.success(response.message || 'VoltUp ID Card Marked Defective !');
      dispatch(updateQueryParams(setQueryParams(queryParams)));
    } catch(error) {
      setShowMarkDefectiveModal(true);
      toast.error(error?.message || 'Something went wrong !');
    }
  }

  return <Modal
    show={showMarkDefectiveModal}
    onHide={handleModalClose}
    backdrop="static"
    keyboard={false}
    centered
  >
    <Modal.Header
      style={{ backgroundImage: 'linear-gradient(103deg, #49c12b 0, #197800 99%)' }}
      className="text-white"
      closeButton
    >
      <Modal.Title>Mark Voltup ID Card Defective</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <div className='text-center m-2 text-warning'><FontAwesomeIcon icon={faCircleExclamation} style={{ fontSize: '80px'}}/></div>
      <p className='h4 text-center my-3 opacity-75'>Are you sure ?</p>
      <p className='h6 text-center my-3 opacity-75 fw-normal'>
        You want to mark defective Rfid <span className="fw-bold">{rfidDetails.serial_no} - {rfidDetails.owner_name} ({rfidDetails.id})</span> ?
      </p>
    </Modal.Body>
    <Modal.Footer>
      <button type="button" className="btn btn-sm rounded-5 btn-outline-secondary" style={{ width: "80px", fontSize: '16px' }} onClick={handleModalClose}>
        Cancel
      </button>
      <button type='submit' className='btn btn-sm remove-button' style={{ width: "180px", fontSize: '16px' }} onClick={(e) => {e.preventDefault(); onMarkDefectiveRfidClick()}}>
        Mark Defective
      </button>
    </Modal.Footer>
  </Modal>
}

export default MarkDefectiveModal;